import type { OwaDate } from 'owa-datetime';
import { lazyShowSurfaceContextMenu } from 'owa-calendar-surface-contextmenu-actions';

/**
 * Open calendar Surface context menu
 */
export function openSurfaceContextMenu(
    start: OwaDate,
    end: OwaDate,
    isAllDay: boolean,
    clickEvent: MouseEvent,
    selectedCalendarFolderId?: string
) {
    lazyShowSurfaceContextMenu.importAndExecute(
        start,
        end,
        isAllDay,
        clickEvent,
        selectedCalendarFolderId
    );
}
